// extracted by mini-css-extract-plugin
module.exports = {"Upload":"FileInput_Upload__3G0IV"};